import { ComponentTree } from "UI/UI/LogicalTree/ComponentTree";
import { Event } from "../Events";
import { IDisposable } from "../IDisposable";
import { IComponentTree, IComponentTreeVisitorResult } from "./IComponentTree";
import { ILogicalComponentBase } from "./ILogicalComponentBase";
import { IRightsContext } from "./IRightsContext";
import { IHasRights, IItemRightsCollection } from "./RightTypes";

/**
 * TODO-rites
 *
 * @generateInstanceClass
 */
export interface IRightsManager<TRightType, TComponent, TComponentType> extends IDisposable {

    /**
     * Nastaví manageru strom komponent, nad kterým má pracovat
     * @param componentTreeGetter Funkce vracející strom komponent
     */
    setComponentTree(componentTreeGetter: () => IComponentTree<ILogicalComponentBase<TRightType, TComponent, TComponentType>, TComponentType>): void;

    /**
     * Vstupní metoda vyhodnocení daných typů práv
     * @param rightTypes Typy práv, které se mají vyhodnotit
     * @param context Kontext, vzhledem ke kterému se vyhodnocují práva
     * @param usesFormRights Formulářová práva by se měla aplikovat, pokud je frame hlavním framem nebo pokud je to detail k hlavnímu seznamu
     * @param priorityRightTypes Typy práv, které se mají prioritně vyhodnotit
     * @param foreignContextEvaluation Zda probíhá vyhodnocení práv v nestandardním kontextu
     */
    evaluateRights(rightTypes: TRightType[], context: IRightsContext | null, usesFormRights?: boolean, priorityRightTypes?: TRightType[], foreignContextEvaluation?: boolean): Promise<void>;

    /**
     * Vrací vyhodnocovač práv framu této implementace IRightsManageru
     * TODO-rites skrýt, mělo by být vnitřní záležitostí
     */
    getFrameRightsEvaluator(): (...params: any[]) => Promise<IComponentTreeVisitorResult>;

    /**
     * Hledá kolekci práv daného uzlu v ComponentTree
     * @param predicate Predikát, podle kterého se má hledat
     */
    findRightsCollectionForControl(predicate: (node: ComponentTree) => boolean): { evaluatedRights: IHasRights; rights: IItemRightsCollection } | undefined;

    /**
     * Událost vyvolána před spuštěním vyhodnocením práv
     */
    readonly rightsEvaluating: Event<IRightsManager<TRightType, TComponent, TComponentType>, IRightsContext>;
    /**
     * Událost vyvolaná po vyhodnocení práv
     */
    readonly rightsEvaluated: Event<IRightsManager<TRightType, TComponent, TComponentType>, IRightsContext>;
    /** Čítač probíhajících vyhodnocování práv */
    readonly runningEvaluationsCount: number;
}

// eslint-disable-next-line unused-imports/no-unused-vars
export class IRightsManager<TRightType, TComponent, TComponentType> {
    private static _properties: string[] = [];
    private static _methods: (keyof IRightsManager<any, any, any>)[] = ["setComponentTree", "evaluateRights", "getFrameRightsEvaluator"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value)) &&
            !this._methods.some(value => typeof instance[value] !== "function") &&
            instance instanceof IDisposable;
    }
}
